// Empire Apps Chassis · connectors/financial · storage-kv
// Cross-runtime key-value: localStorage in browser, in-memory Map in Bun/Node.
// Used by every connector to persist tiny status records.

const memory = new Map<string, string>();

function hasLocalStorage(): boolean {
  return typeof globalThis !== 'undefined' && typeof (globalThis as { localStorage?: Storage }).localStorage !== 'undefined';
}

export function kvGet(key: string): string | null {
  if (hasLocalStorage()) {
    try {
      return (globalThis as { localStorage: Storage }).localStorage.getItem(key);
    } catch {
      return memory.get(key) ?? null;
    }
  }
  return memory.get(key) ?? null;
}

export function kvSet(key: string, value: string): void {
  if (hasLocalStorage()) {
    try {
      (globalThis as { localStorage: Storage }).localStorage.setItem(key, value);
      return;
    } catch {
      memory.set(key, value);
      return;
    }
  }
  memory.set(key, value);
}

export function kvDel(key: string): void {
  if (hasLocalStorage()) {
    try {
      (globalThis as { localStorage: Storage }).localStorage.removeItem(key);
      return;
    } catch {
      memory.delete(key);
      return;
    }
  }
  memory.delete(key);
}

export function kvReadJson<T>(key: string, fallback: T): T {
  const raw = kvGet(key);
  if (raw === null) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function kvWriteJson<T>(key: string, value: T): void {
  kvSet(key, JSON.stringify(value));
}
